import { AlertTriangle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// Bandeau piloté par MODE_DEMO (côté serveur : user.mode_demo). Masqué en production.
export function SyntheticBanner() {
  const { user } = useAuth();
  if (!user?.mode_demo) return null;
  return (
    <div data-testid="synthetic-banner"
      className="fixed bottom-0 inset-x-0 z-[60] bg-amber-500 text-amber-950 text-[11px] md:text-xs font-semibold tracking-wide flex items-center justify-center gap-2 py-1 px-3">
      <AlertTriangle className="w-3.5 h-3.5" />
      DONNÉES SYNTHÉTIQUES · NE PAS DIFFUSER · SYNTHETIC DATA · DO NOT DISTRIBUTE
    </div>
  );
}
